namespace Nobox.CRM {
    export interface TaskboardlistRow {
        Id?: number;
        BoardId?: number;
        ListId?: number;
        Urutan?: number;
        In?: string;
        Up?: string;
        InBy?: number;
        UpBy?: number;
        BoardNama?: string;
        BoardDeskripsi?: string;
        BoardIn?: string;
        BoardUp?: string;
        BoardInBy?: number;
        BoardUpBy?: number;
        ListNama?: string;
        ListIn?: string;
        ListUp?: string;
        ListInBy?: number;
        ListUpBy?: number;
    }

    export namespace TaskboardlistRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Nobox.Taskboardlist';
        export const deletePermission = 'Tasks:Delete';
        export const insertPermission = 'Tasks:Modify';
        export const readPermission = 'Tasks:View';
        export const updatePermission = 'Tasks:Modify';

        export declare const enum Fields {
            Id = "Id",
            BoardId = "BoardId",
            ListId = "ListId",
            Urutan = "Urutan",
            In = "In",
            Up = "Up",
            InBy = "InBy",
            UpBy = "UpBy",
            BoardNama = "BoardNama",
            BoardDeskripsi = "BoardDeskripsi",
            BoardIn = "BoardIn",
            BoardUp = "BoardUp",
            BoardInBy = "BoardInBy",
            BoardUpBy = "BoardUpBy",
            ListNama = "ListNama",
            ListIn = "ListIn",
            ListUp = "ListUp",
            ListInBy = "ListInBy",
            ListUpBy = "ListUpBy"
        }
    }
}
